<template>
  <!-- <el-menu class="left_menu" :default-openeds="['1', '2', '3', '4', '5', '6', '7', '8']" :default-active.sync="defaultActive"> -->
  <el-menu class="left_menu" :default-openeds="defaultOpeneds" :default-active.sync="defaultActive">
    <el-submenu index="1">
      <template slot="title"><i class="el-icon-message"></i>人员管理</template>
      <el-menu-item-group>
        <el-menu-item index="student" @click="goto('/student')">学生信息</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="manager" @click="goto('/manager')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">管理员信息</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="batchOperation" @click="goto('/batchOperation')"
          v-if="['1'].indexOf(userInfo.userType) != -1">批量操作</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="generateCaptcha" @click="goto('/generateCaptcha')"
          v-if="['1'].indexOf(userInfo.userType) != -1">生成验证码</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="userCardNoChangeHistory" @click="goto('/userCardNoChangeHistory')"
          v-if="['1'].indexOf(userInfo.userType) != -1">卡号修改记录</el-menu-item>
      </el-menu-item-group>
      <!-- <el-menu-item-group>
          <el-menu-item index="meetingPicture" @click="goto('/meetingPicture')" v-if="['1'].indexOf(userInfo.userType) != -1">考勤机人脸图</el-menu-item>
        </el-menu-item-group> -->
    </el-submenu>
    <el-submenu index="2" v-if="['1', '2'].indexOf(userInfo.userType) != -1">
      <template slot="title"><i class="el-icon-message"></i>学校管理</template>
      <el-menu-item-group>
        <el-menu-item index="school" @click="goto('/school')"
          v-if="['1'].indexOf(userInfo.userType) != -1">学校信息</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="class" @click="goto('/class')"
          v-if="['1', '2'].indexOf(userInfo.userType) != -1">班级信息</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="grade" @click="goto('/grade')"
          v-if="['1'].indexOf(userInfo.userType) != -1">年级信息</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="staffGroup" @click="goto('/staffGroup')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">职员分组</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="schoolWorkDay" @click="goto('/schoolWorkDay')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">工作日</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="telzone" @click="goto('/telzone')"
          v-if="['1'].indexOf(userInfo.userType) != -1">电话区</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="3">
      <template slot="title"><i class="el-icon-message"></i>考勤管理</template>
      <el-menu-item-group>
        <el-menu-item index="attendence" @click="goto('/attendence')"
          v-if="['1', '2', '4'].indexOf(userInfo.userType) != -1">考勤记录</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="attendenceStats" @click="goto('/attendenceStats')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">教职员考勤日报表</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="attendenceStatsWeek" @click="goto('/attendenceStatsWeek')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">教职员考勤周报表</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="attendenceStatsMonth" @click="goto('/attendenceStatsMonth')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin">教职员考勤月报表</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="attendenceStatsOfNingweiMiddleSchool"
          @click="goto('/attendenceStatsOfNingweiMiddleSchool')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin && null != userInfo.schoolIdList && userInfo.schoolIdList.indexOf(32) != -1">宁围初中考勤报表</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="readerRecord" @click="goto('/readerRecord')"
          v-if="['1'].indexOf(userInfo.userType) != -1">读卡查询</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForStudentReader" @click="goto('/statsForStudentReader')"
          v-if="['1'].indexOf(userInfo.userType) != -1">学校学生考勤统计</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForClassStudentReader" @click="goto('/statsForClassStudentReader')"
          v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin || userInfo.isFaculty && null != userInfo.allowEditClassIdList">班级学生考勤统计</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForReadRate" @click="goto('/statsForReadRate')"
          v-if="['1'].indexOf(userInfo.userType) != -1">实时刷卡率统计</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="strangerMeetingRecord" @click="goto('/strangerMeetingRecord')"
          v-if="['1', '2'].indexOf(userInfo.userType) != -1">陌生人天乔记录</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="4" v-if="['1'].indexOf(userInfo.userType) != -1">
      <template slot="title"><i class="el-icon-message"></i>财务管理</template>
      <el-menu-item-group>
        <el-menu-item index="order" @click="goto('/order')">订单记录</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="refund" @click="goto('/refund')">退款记录</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="changeCard" @click="goto('/changeCard')">换卡管理</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForOrder" @click="goto('/statsForOrder')">订单统计</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForYearFee" @click="goto('/statsForYearFee')">年费统计</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="statsForOrderAmount" @click="goto('/statsForOrderAmount')">月度总额统计</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="5" v-if="['1', '2'].indexOf(userInfo.userType) != -1">
      <template slot="title"><i class="el-icon-message"></i>通知管理</template>
      <el-menu-item-group>
        <el-menu-item index="sendMessage" @click="goto('/sendMessage')">发送通知</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="sendCourseMessage" @click="goto('/sendCourseMessage')">发送成绩</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="sendSalaryMessage" @click="goto('/sendSalaryMessage')">发送工资条</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="notifyRecord" @click="goto('/notifyRecord')">历史通知</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="6" v-if="['1'].indexOf(userInfo.userType) != -1">
      <template slot="title"><i class="el-icon-message"></i>发送记录</template>
      <el-menu-item-group>
        <el-menu-item index="messageSendForAttendance" @click="goto('/messageSendForAttendance')">考勤发送记录</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="messageSendForNotify" @click="goto('/messageSendForNotify')">通知发送记录</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="7"
      v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyCanteenStaff || userInfo.isFacultyCanteenAccountant">
      <template slot="title"><i class="el-icon-message"></i>食堂管理</template>
      <el-menu-item-group>
        <el-menu-item index="canteenSettings" @click="goto('/canteenSettings')">食堂综合配置</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenAccount" @click="goto('/canteenAccount')">食堂用户账户</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenGoods" @click="goto('/canteenGoods')">食堂货品</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenWeekMenu" @click="goto('/canteenWeekMenu')">食堂周菜单</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenOrder" @click="goto('/canteenOrder')">食堂订单</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenOrderDetail" @click="goto('/canteenOrderDetail')">食堂订单明细</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenTransaction" @click="goto('/canteenTransaction')">交易记录</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="canteenMonthReport" @click="goto('/canteenMonthReport')">月报表</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="8"
      v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyCanteenStaff || userInfo.isFacultyCanteenAccountant">
      <template slot="title"><i class="el-icon-message"></i>学生点餐</template>
      <el-menu-item-group>
        <el-menu-item index="studentCanteenGoods" @click="goto('/studentCanteenGoods')">套餐设置</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="studentCanteenSchedule" @click="goto('/studentCanteenSchedule')">日程设置</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="studentCanteenMenu" @click="goto('/studentCanteenMenu')">点餐排单</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="studentCanteenOrder" @click="goto('/studentCanteenOrder')">订单查询</el-menu-item>
      </el-menu-item-group>
      <!-- <el-menu-item-group>
        <el-menu-item index="studentCanteenTransaction" @click="goto('/studentCanteenTransaction')">历史记录</el-menu-item>
      </el-menu-item-group> -->
    </el-submenu>
    <el-submenu index="9" v-if="['1'].indexOf(userInfo.userType) != -1">
      <template slot="title"><i class="el-icon-message"></i>其它功能</template>
      <el-menu-item-group>
        <el-menu-item index="cardPicture" @click="goto('/cardPicture')">卡片图</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="faceImage" @click="goto('/faceImage')">人脸图</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="tianqiaoTempMeetingFace" @click="goto('/tianqiaoTempMeetingFace')">天乔新生</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group>
        <el-menu-item index="tianqiaoDevice" @click="goto('/tianqiaoDevice')">天乔设备</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="10"
      v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin && null != userInfo.schoolIdList && userInfo.schoolIdList.indexOf(138) != -1">
      <template slot="title"><i class="el-icon-message"></i>学校活动</template>
      <el-menu-item-group>
        <el-menu-item index="bodyTemperatureCollection" @click="goto('/bodyTemperatureCollection')">体温填报</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default ({
  data () {
    return {
      defaultActive: this.$route.path.replace(/^\//g, ''),
      userInfo: {},
      defaultOpeneds: []
    }
  },
  methods: {
    goto (url) {
      this.$emit('GoTo', url)
    }
  },
  created () {
    let routeUrlArr = /\/([^/]+)$/.exec(window.location.href)
    if (routeUrlArr.length === 2) {
      let routeUrl = routeUrlArr[1]
      if (['student', 'manager', 'batchOperation', 'generateCaptcha', 'userCardNoChangeHistory', 'meetingPicture'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['1']
      } else if (['school', 'class', 'grade', 'staffGroup', 'schoolWorkDay', 'telzone'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['2']
      } else if (['attendence', 'attendenceStats', 'attendenceStatsWeek', 'attendenceStatsMonth', 'attendenceStatsOfNingweiMiddleSchool', 'readerRecord', 'statsForStudentReader', 'statsForReadRate'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['3']
      } else if (['order', 'refund', 'changeCard', 'statsForOrder', 'statsForOrderMonth'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['4']
      } else if (['sendMessage', 'sendCourseMessage', 'sendSalaryMessage', 'notifyRecord'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['5']
      } else if (['messageSendForAttendance', 'messageSendForNotify'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['6']
      } else if (['canteenSettings', 'canteenAccount', 'canteenGoods', 'canteenWeekMenu', 'canteenOrder', 'canteenOrderDetail', 'canteenTransaction', 'canteenMonthReport'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['7']
      } else if (['studentCanteenGoods', 'studentCanteenSchedule', 'studentCanteenMenu', 'studentCanteenOrder', 'studentCanteenTransaction'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['8']
      } else if (['cardPicture', 'faceImage', 'tianqiaoTempMeetingFace'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['9']
      } else if (['bodyTemperatureCollection'].indexOf(routeUrl) >= 0) {
        this.defaultOpeneds = ['10']
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      console.log(this.userInfo)
    }
  }
})
</script>

<style>
.left_menu .el-menu-item-group__title {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue